interface Result {
  val: number[];
  total: number;
}

export class Dice {
  private diceResult: Result = { val: [], total: 0 };
  public roll(diceNum: number, diceMax: number) {
    const valArr: number[] = [];
    const math = (prev: number, current: number) => prev + current;

    for (let i = 0; i < diceNum; i++) {
      valArr.push(Math.floor(Math.random() * diceMax) + 1);
    }

    this.diceResult.val = valArr;
    this.diceResult.total = valArr.reduce(math);

    return { val: valArr, total: valArr.reduce(math) };
  }
}
